import api from "./api";

export const getChargers = async () => {
  const res = await api.get("/chargers");
  return res.data;
};
